import { SPIFF_RULE_EVENTS } from "@/spiff-rules/constants";
import { ISpiff } from "@/spiffs/spiffs.d";
import { ClosedReferralTriggerDetails } from "./closed-referral-trigger-details";
import { CustomerTriggerDetails } from "./customer-trigger-details";
import { NewReferralTriggerDetails } from "./new-referral-trigger-details";
import { PlaceholderTriggerDetails } from "./placeholder-trigger-details";
import { PricebookItemTriggerDetails } from "./pricebook-item-trigger-details";
import { ReviewTriggerDetails } from "./review-trigger-details";
import { YardSignPhotoTriggerDetails } from "./yard-sign-photo-trigger-details";

interface SpiffTriggerDetailsProps {
  spiff: ISpiff;
}

export const SpiffTriggerDetails = ({ spiff }: SpiffTriggerDetailsProps) => {
  switch (spiff.trigger_event) {
    case SPIFF_RULE_EVENTS.signup:
      return <CustomerTriggerDetails spiff={spiff} />;

    case SPIFF_RULE_EVENTS.referral_creation:
      return <NewReferralTriggerDetails spiff={spiff} />;

    case SPIFF_RULE_EVENTS.referral_completion:
      return <ClosedReferralTriggerDetails spiff={spiff} />;

    case SPIFF_RULE_EVENTS.five_star_review:
      return <ReviewTriggerDetails spiff={spiff} />;

    case SPIFF_RULE_EVENTS.yard_sign_photo:
      return <YardSignPhotoTriggerDetails spiff={spiff} />;

    case SPIFF_RULE_EVENTS.pricebook_item_sale:
      return <PricebookItemTriggerDetails spiff={spiff} />;

    case SPIFF_RULE_EVENTS.tech_generated_lead:
    case SPIFF_RULE_EVENTS.driving_score:
      return <PlaceholderTriggerDetails spiff={spiff} />;

    default:
      return null;
  }
};
